/**
 * sl-m82f.4.2: AI Memory feature tab. Per-bot memory usage breakdown.
 */
import { useI18n } from '@affine/i18n';

import { fetchMemoryByBot } from '../api';
import type { AnalyticsPeriodRange, FeatureTotals } from '../types';
import { LabeledFeatureTab } from './labeled-feature-tab';

export interface AiMemoryTabProps {
  workspaceId: string;
  period: string | AnalyticsPeriodRange;
  featureTotals: FeatureTotals;
}

export const AiMemoryTab = ({
  workspaceId,
  period,
  featureTotals,
}: AiMemoryTabProps) => {
  const t = useI18n();
  return (
    <LabeledFeatureTab
      cacheKey="ai-memory"
      workspaceId={workspaceId}
      period={period}
      featureCredits={featureTotals.features.aiMemory}
      fetcher={fetchMemoryByBot}
      nameHeader={
        t[
          'com.streamlain.settings.workspace.ai.analytics.table.agent-header'
        ]?.() ?? 'Agent'
      }
      itemsLabel={
        t[
          'com.streamlain.settings.workspace.ai.analytics.card.agents-active'
        ]?.() ?? 'Active agents'
      }
      topLabel={
        t[
          'com.streamlain.settings.workspace.ai.analytics.card.top-agent'
        ]?.() ?? 'Top agent'
      }
      emptyLabel={
        t['com.streamlain.settings.workspace.ai.analytics.empty.agents']?.() ??
        'No memory operations in this period'
      }
      countLabel={
        t[
          'com.streamlain.settings.workspace.ai.analytics.table.operations-header'
        ]?.() ?? 'Operations'
      }
    />
  );
};
